import { DependencyList, EffectCallback, useEffect, useRef } from "react";

/**
 * Like `useEffect`, but skips the initial mount — the effect runs only when a
 * dependency changes after the first render. Useful for reacting to a value
 * change (e.g. a route param) without the redundant run a plain `useEffect`
 * fires on mount.
 */
export const useUpdateEffect = (effect: EffectCallback, deps?: DependencyList): void => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return undefined;
    }
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
